mutation DeleteSentenceRecording($sentenceRecording: ID!) {
  deleteSentenceRecording(sentenceRecording: $sentenceRecording) {
    ok
    errors
  }
}
